<template>
  <page-loader v-if="loadingStatus == 'loading'" />

  <div class="contain-section" v-else-if="introduction">
    <div class="align-items-start">
      <div class="d-flex align-items-center gap-3 mb-5">
        <img v-if="sharingStore.photo" :src="sharingStore.photo" class="img-thumbnail d-block avtar-100"
          alt="profile image">
        <h1 class="m-0">{{ sharingStore.name }}'s Baker Profile</h1>
      </div>
      <p><strong>These are <span>{{ sharingStore.name.split(" ")[0] }}'s baker results</span>. This is a public
          summary of their results which
          they
          have
          chosen
          to share with their friends and family</strong></p>
    </div>

    <div class="row">
      <section class="col-sm-12 col-md-12 col-lg-12">
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-6 left-card">
            <div class="population-group text-left">
              <img class="population-icon" src="@/assets/bakers/warwatson.png" alt="Vector">
              <!-- <p class="card-text title text-center">Your Baking Genetic Score </p> -->
              <h4>Your Genetic Baking Score </h4>
              <!-- Chart -->
              <div class="progress-wrapperbaker" v-if="parsedResults">
                <DoughnutChart :chart-data="chartData" ChartColor="rgb(243, 112, 33)" :centerTitle="scoreValue + '%'"
                  centerSubtitle="Score" :centerTitleStyle="{ fontSize: '30px', fontWeight: 'bold' }"
                  :centerSubtitleStyle="{ fontSize: '14px', fontWeight: '500' }" :titleOffsetY="0" :subtitleOffsetY="25"
                  :options="{ cutout: '85%', ...options }" chartWidth="190px" chartHeight="190px" />
              </div>
              <!-- Result -->
              <h4 class="card-text text-center">{{ bakerLevel.result }}</h4>
              <!-- Description -->
              <p class="description text-center">
                {{ bakerLevel.advice_definition }}
              </p>
              <br>
              <!-- Percentile Bar -->
              <div v-if="parsedResults" class="percentile-wrapper">
                <div class="bar">
                  <div class="bar-fill" :style="{ width: parsedResults?.percentile + '%' }"></div>
                </div>
              </div>

              <!-- Percentile Text -->
              <div class="traits-sectionarctype"></div>
              <div class="row mobile-flex">
                <div class="col-sm-10 col-md-10 col-lg-10">
                  <p class="text-start mb-1"> Population Percentile:</p>
                </div>
                <div class="col-sm-2 col-md-2 col-lg-2 text-right">
                  <p class="text-right  mb-1"> {{ parsedResults?.percentile ? getOrdinal(parsedResults.percentile) : ''
                    }}</p>
                </div>
              </div>
              <!-- Segmented Bar -->
              <div class="bar">
                <div v-for="i in segments" :key="i" class="segment" :style="segmentStyle(i, parsedResults?.percentile)">
                </div>
              </div>
              <!-- Top % -->
              <p class="text-end">
                Top {{ 100 - (parsedResults?.percentile || 0) }}% of the UK
              </p>
              <div class="traits-section">
                <div class="text-center">
                  <div class="trait-pilldomain">
                    {{ parsedResults?.percentile > 50
                      ? 'Above average genetic predisposition'
                      : 'Below average genetic predisposition' }}
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-sm-12 col-md-6 col-lg-6 right-card mobile-hidden">
            <div class="population-group">
              <img class="population-icon" src="@/assets/bakers/warwatson.png" alt="Vector">

              <div class="row">
                <div class="col-12 mobile-padd-0">
                  <!-- <p class='text-center' style="font-size: 14px;">Your Radar Chart</p> -->
                  <h4 class="text-black">Your Radar Chart</h4>
                  <div class="radar-container">
                    <Radar :data="chartDatagraph" :options="chartOptionsgraph" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6 left-card">
              <div class="population-group">
                <img class="population-icon" src="@/assets/bakers/warwatson.png" alt="Vector">

                <div class="row">
                  <div class="col-12">
                    <!-- <p class='text-center' style="font-size: 14px;">Your Baking Archetype</p> -->
                    <h4>Your Baking Archetype</h4>
                    <h1 class="archetype-title"></h1>
                    <h3 class="text-start">{{ introductionphenotype?.result }}</h3>
                    <div class="text-start">
                      {{ introductionphenotype?.advice_one_liner_text }}</div>
                    <p class="text-start">
                      {{ introductionphenotype?.advice_definition }}
                    </p>
                    <div class="traits-section">
                      <div class="traits-grid">
                        <div v-for="(sub, index) in parsedResults?.tags?.domain || []" :key="index"
                          class="trait-pilldomain">{{ sub }}</div>
                        <div class="trait-pillsubtrait" v-for="(sub, index) in parsedResults?.tags?.subtrait || []"
                          :key="index">{{ sub }}</div>
                        <div class="trait-pillprofile" v-for="(sub, index) in parsedResults?.tags?.profile || []"
                          :key="index">{{ sub }}</div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            
          <div class="col-sm-12 col-md-6 col-lg-6 desktop-hidden">
            <div class="population-group">
              <img class="population-icon" src="@/assets/bakers/warwatson.png" alt="Vector">

              <div class="row">
                <div class="col-12 mobile-padd-0">
                  <!-- <p class='text-center' style="font-size: 14px;">Your Radar Chart</p> -->
                  <h4 class="text-black">Your Radar Chart</h4>
                  <div class="radar-container">
                    <Radar :data="chartDatagraph" :options="chartOptionsgraph" />
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div class="col-sm-12 col-md-6 col-lg-6 right-card text-center">
              <img src="@/assets/bakers/bakersoverview.png" class="imagebakers" style="height: 290px;">
            </div>
          </div>
          <div class="col-sm-12 col-lg-12 col-xl-12 " v-for="(trait, index) in traits" :key="index">
            <div class="inner-box">
              <div>
                <div class="card-header">
                  <h3> {{ trait.name }} </h3>
                  <span class="score">{{ percent(trait.total?.total_score) }}% Score</span>
                </div>
                <div class="chart-grid px-3">
                  <!-- <div class="item chart-column " v-for="(sub, sIndex) in trait.subtraitsArray" :key="sIndex"
                    :class="`column-${Math.floor(sIndex / 2)}`" @click="openPopup(trait, sub)"> -->
                  <div class="item chart-column " v-for="(sub, sIndex) in trait.subtraitsArray" :key="sIndex"
                    :class="`column-${Math.floor(sIndex / 2)}`">
                    <div class="subtrait-row">
                      <div class="row">
                        <div class="col-8 col-sm-8 col-lg-8"> <span class="label">{{ sub.name }}</span>
                        </div>
                        <div class="col-4 col-sm-4 col-lg-4 item-right">
                          <!-- <span class="negativestatus"
                            v-if="percent(sub.total?.total_score) < 40">Negative</span>
                          <span class="intermidiatestatus"
                            v-else-if="percent(sub.total?.total_score) <= 60">Intermediate</span>
                          <span class="status" v-else>Positive</span> -->
                          <span :class="getStatus(sub.total?.total_phenotype_slug)">
                            {{
                              sub.total?.total_phenotype_slug?.split(':')[1]?.charAt(0).toUpperCase() +
                              sub.total?.total_phenotype_slug?.split(':')[1]?.slice(1)
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- CENTRALIZED POPUP -->
                  <div v-if="activePopup" class="popup-overlay" @mouseleave="closePopup()">
                    <div class="popup-card">
                      <button class="popup-close" @click="closePopup()">
                        ✕
                      </button>
                      <div class="popup-content">
                        <div class="popup-left">
                          <img src="@/assets/bakers/logo-1.png" class="popup-logo-img">
                          <img src="@/assets/bakers/girl.png" class="popup-girl-img">
                        </div>

                        <div class="popup-right">
                          <div class="chart-wrapper1">
                            <div class="chart-grid1">
                              <div v-for="(item, i) in popupContent.bars" :key="i" class="chart-column1">
                                <div class="chart-row1">
                                  <div class="bar-label-container">
                                    <span class="popup-trait-label">{{ item.label }} -</span>
                                    <span class="popup-trait-value"> {{ item.value }}%</span>
                                  </div>
                                  <div class="bar">
                                    <div v-for="index in segments" :key="index" class="segment"
                                      :style="segmentStyle(index, item.value)" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <h2 style=" margin-top: 40px;">{{ popupContent.title }}</h2>
                          <div class="popup-info">
                            <p>
                              {{ bakersValueDescription }}
                            </p>
                          </div>
                          <button class="report-btn" @click="goToFullReport">
                            Check Your Full Test Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- END CENTRALIZED POPUP -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

</template>

<script>
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { useSharingStore } from "@/store/sharing";

import DoughnutChart from "@/components/charts/Doughnut.vue";
import {
  getBakersIntroduction,
  getBakersPublicDetailResult,
  getBakerscategoryintrodction,
  getBakersresultstatus,
  getBakersoverviewproduct,
  getBakersdescription,
  getBakersphenotype,
  getBakersvaluetitle
} from "@/services/bakers";
import { Radar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from 'chart.js'

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
)

// Global plugin: manually draw center-aligned radar labels
if (ChartJS.registry.plugins.get('radarLabelCenter')) {
  ChartJS.unregister(ChartJS.registry.plugins.get('radarLabelCenter'));
}

const radarLabelCenterPlugin = {
  id: 'radarLabelCenter',
  afterDraw(chart) {
    const scale = chart.scales.r;
    if (!scale || !scale._pointLabelItems) return;

    const ctx = chart.ctx;
    ctx.save();
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';

    scale._pointLabelItems.forEach((item, i) => {
      const isMobile = chart.width < 320;
      const fontSize = isMobile ? 9 : (item.font?.size || 11);
      const font = item.font || { size: fontSize, family: '"Poppins", sans-serif' };
      ctx.font = `${font.weight || '600'} ${fontSize}px ${font.family || '"Poppins", sans-serif'}`;

      // Detect dark mode and set label color accordingly
      const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches ||
      document.documentElement.classList.contains('dark') ||
      document.body.classList.contains('dark');
      ctx.fillStyle = isDarkMode ? '#000000' : '#000000';

      // Get the EXACT point on the radar grid for absolute symmetry
      const point = scale.getPointPosition(i, scale.drawingArea);
      let x = point.x;
      let y = point.y;
      const sideNudge = isMobile ? 28 : 40;
      const vertNudge = isMobile ? 16 : 20;
      ctx.textAlign = 'center';
      if (i === 0) y -= vertNudge;  // Handling (Top)
      if (i === 1) x += sideNudge;  // Metabolism (Right)
      if (i === 2) y += vertNudge;  // Taste sensitivity (Bottom)
      if (i === 3) x -= sideNudge;  // Smell sensitivity (Left)

      // Handle multi-line labels (Trait + Percentage)
      // Fallback to chart data if item.label is not populated
      const rawLabel = item.label || (chart.data.labels && chart.data.labels[i]) || "";
      const lines = Array.isArray(rawLabel) ? rawLabel : [rawLabel];
      const lineHeight = font.size * 1.3;

      // Calculate startY to vertically center the entire multi-line block on the axis point
      const totalHeight = (lines.length - 1) * lineHeight;
      const startY = y - (totalHeight / 2);

      lines.forEach((line, lineIndex) => {
        ctx.fillText(line, x, startY + (lineIndex * lineHeight));
      });
    });
    ctx.restore();
  }
};
ChartJS.register(radarLabelCenterPlugin);
export default {
  components: { DoughnutChart, Radar },
  name: "BakersDynamicTraitViewer",

  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const sharingStore = useSharingStore();
    const loadingStatus = ref("loading");
    const resultData = ref(null);
    const introduction = ref(null);
    const introductionarchtype = ref(null);
    const introductionphenotype = ref(null);
    const traitIntroductions = ref({});
    const traitimage = ref({});
    const activePopup = ref(null);
    const segments = 10;
    const bakersValueDescription = ref("");
    const slugify = (text) =>
      text?.toLowerCase().replace(/\s+/g, "-");
    const scoreValue = computed(() => {
      return Math.round(parsedResults.value?.score * 100) ?? 0;
    });
    const radius = 50;
    const circumference = 2 * Math.PI * radius;

    const chartDatagraph = computed(() => {
      const traitMap = {
        'Handling': { label: 'Handling', color: '#E86D1E' },
        'Metabolism': { label: 'Metabolism', color: '#E86D1E' },
        'Taste sensitivity': { label: 'Taste sensitivity', color: '#E86D1E' },
        'Smell sensitivity': { label: 'Smell sensitivity', color: '#E86D1E' }
      };

      const labels = [];
      const data = [];
      const pointColors = [];

      Object.keys(traitMap).forEach(key => {
        const traitData = parsedResults.value?.traits?.[key];
        const score = traitData?.total?.total_score ?? 0;
        const percentage = Math.round(score * 100);

        labels.push([traitMap[key].label, `${percentage}%`]);
        data.push(percentage);
        pointColors.push(traitMap[key].color);
      });

      return {
        labels,
        datasets: [
          {
            label: 'Baker Skills',
            data,
            backgroundColor: 'rgba(243, 112, 33, 0.2)', // Light orange fill
            borderColor: '#E86D1E', // Orange border
            borderWidth: 1,
            pointBackgroundColor: pointColors,
            pointBorderColor: '#fff',
            pointRadius: 5,
            pointHoverRadius: 7
          }
        ]
      };
    });

    const radarLegendItems = computed(() => {
      const traitMap = {
        'Handling': { label: 'Handling', color: '#D98C2F' },
        'Metabolism': { label: 'Metabolism', color: '#2F6B4C' },
        'Taste sensitivity': { label: 'Taste sensitivity', color: '#B2844D' },
        'Smell sensitivity': { label: 'Smell sensitivity', color: '#B24D4D' }
      };

      return Object.keys(traitMap).map(key => {
        const traitData = parsedResults.value?.traits?.[key];
        const score = traitData?.total?.total_score ?? 0;
        return {
          label: traitMap[key].label,
          color: traitMap[key].color,
          value: Math.round(score * 100)
        };
      });
    });

    const chartOptionsgraph = {
      layout: {
        padding: { top: 24, bottom: 24, left: 32, right: 32 }
      },
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false
        }
      },
      scales: {
        r: {
          min: 0,
          max: 100,
          beginAtZero: true,
          grid: {
            color: 'rgba(233, 109, 14, 0.15)',
            circular: false
          },
          angleLines: {
            color: 'rgba(221, 55, 163, 0.15)'
          },
          ticks: {
            display: false,
            stepSize: 20
          },
          pointLabels: {
            font: {
              size: 11,
              weight: 100
              // family: "'Poppins', sans-serif"
            },
            color: 'transparent',
            padding: 15
          }
        }
      }
    };
    const offset = computed(() => {
      return circumference - (scoreValue.value / 100) * circumference;
    });
    const barcode = computed(
      () => store.getters.profile?.profile?.barcode || null
    );

    // =============================
    // Fetch global introduction
    // =============================
    getBakersIntroduction()
      .then((res) => {
        introduction.value = res;
        loadingStatus.value = "loaded";
      })
      .catch(() => {
        loadingStatus.value = "loadingFailed";
      });



    // =============================
    // Fetch result data
    // =============================
    watch(
      barcode,
      async (newBarcode) => {
        console.log(newBarcode)

        loadingStatus.value = "loading";

        try {
          const res = await getBakersPublicDetailResult(route.params.uuid);
          resultData.value = res?.bakers_report;
          loadingStatus.value = "loaded";
        } catch {
          loadingStatus.value = "loadingFailed";
        }
      },
      { immediate: true }
    );

    // =============================
    // Parse result JSON safely
    // =============================
    const parsedResults = computed(() => {
      if (!resultData.value?.results) return null;

      try {
        return JSON.parse(resultData.value.results);
      } catch {
        return null;
      }
    });

    // =============================
    // Format traits structure
    // =============================
    const traits = computed(() => {
      if (!parsedResults.value?.traits) return [];

      return Object.entries(parsedResults.value.traits).map(
        ([traitName, traitData]) => ({
          name: traitName,
          ...traitData,
          subtraitsArray: Object.entries(
            traitData.subtraits || {}
          ).map(([subName, subData]) => ({
            name: subName,
            ...subData,
          })),
        })
      );
    });

    getBakersdescription('baking-archetype:baking-archetype')
      .then((res) => {
        introductionarchtype.value = res;
        //  loadingStatus.value = "loaded";
      })
      .catch(() => {
        // loadingStatus.value = "loadingFailed";
      });

    // =============================
    // Fetch trait intro + image
    // =============================
    watch(
      traits,
      async (newTraits) => {
        if (!newTraits.length) return;

        for (const trait of newTraits) {
          if (!traitIntroductions.value[trait.name]) {
            try {
              const res = await getBakerscategoryintrodction(
                trait.name
              );
              if (trait.name == 'Smell sensitivity') {
                const result = await getBakersoverviewproduct("smell-sensitivity-group");
                traitIntroductions.value[trait.name] = result.description;
                traitimage.value[trait.name] = 'https://living-dna.stream.prepr.io/4bw3djp8oypb//smell-sensitivity.jpg';
              }
              else if (trait.name == 'Metabolism') {
                const result = await getBakersoverviewproduct("metabolism-group");
                traitIntroductions.value[trait.name] = result.description;
                traitimage.value[trait.name] = 'https://living-dna.stream.prepr.io/32sk610b1hs5//boiledeggsx3.jpg';
              }
              else if (trait.name == 'Handling') {
                const result = await getBakersoverviewproduct("handling-group");
                traitIntroductions.value[trait.name] = result.description;
                traitimage.value[trait.name] = 'https://living-dna.stream.prepr.io/2xhnp0rmd7u2//french-toast-1.jpg';
              }
              else if (trait.name == 'Taste sensitivity') {
                const result = await getBakersoverviewproduct("taste-sensitivity-group");
                traitimage.value[trait.name] = 'https://living-dna.stream.prepr.io/7kyph3hunu9e//march-of-the-crumpets-on-blue.jpg';
                traitIntroductions.value[trait.name] = result.description;
              }
              else {
                traitIntroductions.value[trait.name] =
                  res?.body?.replace(/<\/?p>/g, "") ||
                  "Lorem ipsum dolor sit amet consectetur. Purus in et nibh sit gravida. Magna quam ultricies elementum at. Leo sagittis tincidunt egestas cursus. A commodo accumsan aliquet phasellus in risus lectus massa convallis. Tristique posuere tellus diam id maecenas elit lacus. Semper habitant nulla enim pulvinar elit. Duis vitae pellentesque a sapien senectus faucibus. Elit tristique cras interdum morbi at. Duis vitae pellentesque a sapien senectus faucibus. Elit tristique cras interdum morbi at. Duis vitae pellentesque a sapien senectus faucibus. Elit tristique cras interdum morbi at. Lorem ipsum dolor sit amet consectetur. Purus in et nibh sit gravida. Magna quam ultricies";
                traitimage.value[trait.name] = res?.image?.[0]?.url || null;
              }


            } catch {
              traitIntroductions.value[trait.name] =
                "Lorem ipsum dolor sit amet consectetur. Purus in et nibh sit gravida.";

              traitimage.value[trait.name] = null;
            }
          }
        }
      },
      { immediate: true }
    );

    // =============================
    // Helpers
    // =============================
    const percent = (score) => {
      if (score === null || score === undefined) return 0;
      return Math.round(score * 100);
    };

    const segmentStyle = (index, value = 0) => {
      const activeSegments = Math.ceil(
        (value / 100) * segments
      );

      if (index > activeSegments)
        return { backgroundColor: "#EFEFEF" };

      if (index === activeSegments)
        return { backgroundColor: "#E86D1E" };

      return { backgroundColor: "#FFE2CF" };
    };

    // =============================
    // Popup logic
    // =============================
    const openPopup = async (trait, subtrait) => {
      activePopup.value = {
        traitName: trait.name,
        subtraitName: subtrait.name,
        value: percent(subtrait.total?.total_score),
      };

      bakersValueDescription.value = "Loading...";

      try {
        const key = subtrait.name.trim(); // IMPORTANT

        console.log("SENDING:", key);

        const res = await getBakersvaluetitle(key);

        console.log("RESPONSE:", res);

        bakersValueDescription.value =
          res?.definition || "No description found";

      } catch (e) {
        bakersValueDescription.value = "Error loading description";
      }
    };

    const closePopup = () => {
      activePopup.value = null;
    };

    const popupContent = computed(() => {
      if (!activePopup.value) return null;

      return {
        title: `${activePopup.value.traitName}`,
        subtitle: `${activePopup.value.subtraitName}`,
        bars: [
          {
            label: activePopup.value.subtraitName,
            value: activePopup.value.value,
          },
        ],
      };
    });
    const bakerLevel = ref("");

    watch(
      [
        () => parsedResults.value?.archetype,
        () => parsedResults.value?.score
      ],
      async ([archetype, scoreRaw]) => {

        // Archetype logic
        if (archetype) {
          console.log("ARCHETYPE:", archetype);
          try {
            const res = await getBakersphenotype(archetype);
            introductionphenotype.value = res;
          } catch (e) {
            console.error("Phenotype error:", e);
            introductionphenotype.value = null;
          }
        }

        // Score logic
        const score = scoreRaw ? Math.round(scoreRaw * 100) : 0;

        try {
          // if (score <= 20) {
          //   const result = await getBakersresultstatus("baking-overview:The Uninitiated", "The Uninitiated");
          //   bakerLevel.value = result || "The Home Baker";
          // } else if (score <= 35) {
          //   const result = await getBakersresultstatus("baking-overview:The Curious Cook", "The Curious Cook");
          //   bakerLevel.value = result || "The Home Baker";
          // } else if (score <= 50) {
          //   const result = await getBakersresultstatus("baking-overview:The Home Baker", "The Home Baker");
          //   bakerLevel.value = result || "The Home Baker";
          // } else if (score <= 65) {
          //   const result = await getBakersresultstatus("baking-overview:The Natural Baker", "The Natural Baker");
          //   bakerLevel.value = result || "";
          // } else if (score <= 80) {
          //   const result = await getBakersresultstatus("baking-overview:The Gifted Baker", "The Gifted Baker");
          //   bakerLevel.value = result || "The Gifted Baker";
          // } else if (score <= 90) {
          //   const result = await getBakersresultstatus("baking-overview:The Master Baker", "The Master Baker");
          //   bakerLevel.value = result || "The Master Baker";
          // } else {
          //   const result = await getBakersresultstatus("baking-overview:The Born Baker", "The Born Baker");
          //   bakerLevel.value = result || "The Born Baker";
          // }

          const result = await getBakersphenotype(parsedResults.value?.overview);
          bakerLevel.value = result || "";
          console.log("RESULT => ", result); console.log(score);
          console.log(getBakersresultstatus);

        } catch (e) {
          console.error("Score error:", e);
        }

      },
      { immediate: true }
    );
    const goToFullReport = () => {
      if (
        !activePopup.value?.traitName ||
        !activePopup.value?.subtraitName
      )
        return;

      router.push({
        name: "bakers-detail",
        params: {
          category: slugify(activePopup.value.traitName),
          subcat: slugify(activePopup.value.subtraitName),
        },
      });
    };

    const options = {
      plugins: {
        tooltip: {
          enabled: false
        }
      }
    };
    const getOrdinal = (n) => {
      const s = ["th", "st", "nd", "rd"];
      const v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };

    const getStatus = (slug) => {
      return slug?.split(':')?.[1] || 'unknown'
    }

    return {
      getStatus,
      options,
      getOrdinal,
      loadingStatus,
      introduction,
      introductionarchtype,
      introductionphenotype,
      traits,
      traitIntroductions,
      traitimage,
      segments,
      percent,
      segmentStyle,
      activePopup,
      popupContent,
      openPopup,
      closePopup,
      goToFullReport,
      parsedResults,
      scoreValue,
      circumference,
      bakerLevel,
      offset,
      getBakersvaluetitle,
      bakersValueDescription,
      Radar,
      chartDatagraph,
      chartOptionsgraph,
      radarLegendItems,
      sharingStore
    };
  },

  computed: {

    chartData() {
      const score = this.scoreValue || 0;

      return {
        datasets: [
          {
            data: [score, 100 - score],
            backgroundColor: ["#E86D1E", "#ddd"],
          },
        ],
        labels: [],
      };
    },
  },
};

</script>
<style scoped>
.mobile-hidden { display: none; }
.desktop-hidden { display: block; }
@media (min-width: 768px) {
  .mobile-hidden { display: block; }
  .desktop-hidden { display: none !important; }
}

.result-wrapper .inner-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 335px;
}

.item-right {
  text-align: right;
}

figure img {
  -o-object-fit: cover;
  object-fit: fill;

}

.percentpopup {
  display: block;
  color: #000000;
  font-size: 16px;
}

.result-wrapper .inner-content p {

  text-align: justify;
}

.chart-grid {
  text-align: left;
  column-gap: 40px;
  row-gap: 0;
  padding-inline: 0 !important;
}

/* POPUP */
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-card {
  width: 95%;
  max-width: 900px;
  background: linear-gradient(90deg, #E86D1E, #f8c29d);
  border-radius: 20px;
  padding: 30px;
  position: relative;
  overflow-y: auto;
  max-height: 90vh;
}

.popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  border: none;
  background: white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.popup-content {
  display: flex;
  gap: 30px;
  align-items: center;
  justify-content: center;
}

.popup-left img {
  width: 260px;
}

.popup-info p {
  margin: 4px 0;
}

.report-btn {
  margin-top: 20px;
  padding: 12px 24px;
  background: #2f6be5;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.report-btn:hover {
  background: #1e5ad4;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(47, 107, 229, 0.3);
}

.score-card {
  display: flex;
  justify-content: space-between;
  align-items: center;

  border-radius: 12px;
}

.score-text h3 {
  font-weight: 600;
}

.score-text span {
  color: #E86D1E;
  font-size: 32px;
  font-weight: 700;
}

.circle-wrapper {
  position: relative;
  width: 120px;
  height: 120px;
}

.progress-ring {
  transform: rotate(-90deg);
}

.ring-bg {
  fill: none;
  stroke: #e6e6e6;
  stroke-width: 10;
}

.ring-progress {
  fill: none;
  stroke: #E86D1E;
  stroke-width: 10;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.6s ease;
}

.score-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 600;
  font-size: 18px;
}

.score-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.score-row h4 {
  margin: 0;
}

.score-card {
  width: 100%;
  max-width: 200px;
}

.progress-wrapperbaker {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
}

.text-center {
  text-align: center !important;
}

.archetype-title {
  margin: 1rem 0 0.4rem 0;
  line-height: 1.1;
}

.instinctive {
  display: block;
  font-family: 'Playfair Display', serif;
  font-size: 3.4rem;
  font-weight: 300;
  color: #392b1e;
  letter-spacing: -0.02em;
  line-height: 1.1;
  margin-bottom: -0.2rem;
}

.creator {
  display: block;
  font-family: 'Playfair Display', serif;
  font-size: 3.9rem;
  font-weight: 700;
  /* bold for "Creator" */
  color: #2b1c0e;
  letter-spacing: -0.02em;
  line-height: 1;
  margin-top: -0.25rem;

  /* gives a slight stamp effect – matches screenshot vibe */
  font-style: normal;
}

/* sensory / practical line */
.subtitle {
  font-size: 0.85rem;
  letter-spacing: 2.8px;
  word-spacing: 6px;
  color: #8f6746;
  font-weight: 400;
  margin: 1rem 0 1.6rem 0;
  border-bottom: 1px solid #eedacb;
  padding-bottom: 0.8rem;
}

.card-text.title {
  font-size: 16px;
  /* font-family: 'DM Mono', monospace; */
}

.radar-container canvas {
  display: block;
  margin-top: -20px;
  margin-bottom: -20px;
}

/* trait grid */
.traits-section {
  /* margin-top: 1.8rem;
  border-top: 2px solid #e6d3c0; */
  padding-top: 1.5rem;
}

.traits-sectionarctype {

  border-top: 2px solid #e6d3c0;
  padding-top: 0.8rem;
}

.traits-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.trait-pillprofile {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #E86D1E;
  background: #ffffff;
  padding: 6px 14px;
  border-radius: 20px;
  white-space: nowrap;
  transition: all 0.2s ease;
  border: 1px solid #E86D1E;
  /* font-family: 'DM Mono', monospace, system-ui; */
}

.trait-pillprofile:hover {
  background: #ffffff;
  transform: translateY(-1px);
  /* font-family: 'DM Mono', monospace, system-ui; */
}

.trait-pilldomain {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  background: #E86D1E;
  padding: 6px 14px;
  border-radius: 20px;
  white-space: nowrap;
  transition: all 0.2s ease;
  /* font-family: 'DM Mono', monospace, system-ui; */

}

.trait-pilldomain:hover {
  background: #E86D1E;
  transform: translateY(-1px);
  /* font-family: 'DM Mono', monospace, system-ui; */
}

.trait-pillsubtrait {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;

  color: #E86D1E;
  /* text */

  background: rgba(232, 109, 31, 0.1);
  /* 10% opacity */
  border: 1px solid rgba(232, 109, 31, 0.25);
  /* 25% opacity */

  padding: 6px 14px;
  border-radius: 20px;
  white-space: nowrap;
  transition: all 0.2s ease;
  /* font-family: 'DM Mono', monospace, system-ui; */
}

.trait-pillsubtrait:hover {
  background: rgba(232, 109, 31, 0.1);
  /* 10% opacity */
  border: 1px solid rgba(232, 109, 31, 0.25);
  /* 25% opacity */
  transform: translateY(-1px);
  /* font-family: 'DM Mono', monospace, system-ui; */
}

/* subtle fine print / year */
.footer-note {
  margin-top: 2.2rem;
  font-size: 0.7rem;
  text-align: right;
  color: #b39279;
  letter-spacing: 0.6px;
  border-top: 1px dashed #decbb8;
  padding-top: 1rem;
  text-transform: uppercase;
}

.footer-note i {
  font-style: normal;
  background: #f0e1d4;
  padding: 0.2rem 0.8rem;
  border-radius: 30px;
  color: #6d4e34;
}

.card {
  width: 100%;
  max-width: 360px;
  background: #f6f7f8;
  border-radius: 10px;
  padding: 18px;
  font-family: Arial, sans-serif;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  background: transparent;
  border-bottom: none;
  padding: 0 !important;
}

.card-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}

.score {
  background: #ffe6cc;
  color: #E86D1E;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
}

.desc {
  font-size: 13px;
  color: #666;
  margin: 10px 0 15px;
}

.list {
  border-top: 1px solid #e5e5e5;
}

.item {

  justify-content: space-between;
  padding: 10px 0;
}

.label {
  color: #000000;
  font-size: 14px;
  cursor: pointer;
}

.status {
  background: #D6F2DF;
  ;
  color: #1E7A3C;
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}


.negative {
  background: #F9D6DC;
  color: #C0233A;
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  word-wrap: normal;
}

.positive {
  background: #D6F2DF;
  ;
  color: #1E7A3C;
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  word-wrap: normal;
}

.intermediate {
  background: #FFF0B0;
  color: #8A6B00;
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  word-wrap: normal;
}

.untested {
  background: #D3D3D3;
  color: #808080;
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  word-wrap: normal;
}

.negativestatus {
  background: #F9D6DC;
  color: #C0233A;
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  word-wrap: normal;
}

.uk {
  font-family: 'DM Mono', monospace;
}

.arctypelineartext {
  color: #E86D1E;
}

.intermidiatestatus {
  background: #FFF0B0;
  color: #8A6B00;
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.percentage-area-rowx .chart-center-title {
  display: block;
  margin-bottom: 5px;
  /* adds space between title and subtitle */
}

.subtrait-row {

  align-items: center;
  /* vertically center text */
  gap: 10px;
  /* space between spans */
}

/* RADAR CHART */
.radar-card {
  background: #fdfaf5;
  border-radius: 25px;
  padding: 50px 30px;
  width: 100%;
  max-width: 500px;
  margin: 30px auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

.radar-header {
  text-align: center;
  margin-bottom: 40px;
}

.radar-title {
  font-size: 13px;
  letter-spacing: 5px;
  color: #b2937c;
  font-weight: 500;
  text-transform: uppercase;
}

.radar-container {
  width: 100%;
  height: 350px;
  margin: 0 auto 40px;
}

.radar-legend-container {
  display: grid;
  grid-template-columns: 20px 1fr auto;
  row-gap: 15px;
  column-gap: 15px;
  align-items: center;
  padding: 0 40px;
}

.radar-legend-row {
  display: contents;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.legend-label {
  font-size: 15px;
  color: #6d4e34;
  font-weight: 500;
}

.legend-value {
  font-size: 18px;
  color: #E86D1E;
  font-weight: 700;
  font-family: 'Courier New', Courier, monospace;
}

.population-icon {

  /* Hide icon if it clutters the new radar design */
}

@media screen and (max-width: 996px) {
  .chart-grid {
    grid-template-columns: 1fr;
  }
}

.population-icon {
  width: 100px;
}

.population-group {
  transition: all 0.3s ease;
  text-align: center;
}

.population-group:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.result-wrapper .population-group .population-icon {

  display: none;
}

.result-wrapper .banner-box {

  display: unset;

}

.result-wrapper .population-group p {
  font-size: 14px;
}

@media screen and (max-width: 767px) {
  .mobile-flex .col-sm-10 {
    width: 70%;
  }

  .mobile-flex .col-sm-2 {
    width: 30%;
    text-align: right;
  }

  .radar-container {
    height: auto !important;
    margin-bottom: 0;
  }

  .result-wrapper .population-group,
  .result-wrapper .inner-box {
    padding-inline: 0;
    margin-bottom: 0;
  }

  .result-wrapper .inner-box {
    padding-bottom: 0;
  }

}

@media screen and (max-width: 576px) {

  .trait-pillsubtrait,
  .trait-pilldomain,
  .trait-pillprofile {
    font-size: 11px;
  }
  .subtrait-row .col-8 {
    width: 60%;
  }
  .subtrait-row .col-4 {
    width: 40%;
  }
  .mobile-padd-0{
    padding-inline: 0 !important;
  }
}
</style>
